var map = {
	"./brownrice.jpg": 97,
	"./lettuce.jpg": 98,
	"./lettucerice.jpg": 99,
	"./sushirice.jpg": 100
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/base ^\.\/.*$
// module id = 96
// module chunks = 0